import React, { Component } from "react";
import styles from "./intelligenceVidioPlayer.module.scss";
import { withVideoTools } from "../../../shared/containers/containerVideoTools";
import { MenuItem, Select, InputLabel } from "@mui/material";
import { withChoosedCar } from "../../../shared/containers/containerChoosedCar";
import { withCars } from "../../../shared/containers/containerCars";

class IntelligenceVidioPlayer extends Component {
  componentDidMount() {
    const { onSetStateVideoPanel, listUnits, choosedCarId, dateStart, dateEnd, speedPlay } = this.props;

    const data = listUnits.filter((x) => {
      return x.id === choosedCarId;
    })[0];

    if (data.howenDevice === null) {
      onSetStateVideoPanel(false, null, null, false, dateStart, dateEnd, speedPlay);
    } else {
      onSetStateVideoPanel(true, data.howenDevice.otherId, data.howenDevice.channels, false, dateStart, dateEnd, speedPlay);
    }
  }

  onHandleChangeStore(e) {
    const { onSetStateVideoPanel, listUnits, choosedCarId, isOpenVideoPanel, dateStart, dateEnd, speedPlay } = this.props;

    if (speedPlay === e.target.value) return;

    const data = listUnits.filter((x) => {
      return x.id === choosedCarId;
    })[0];

    onSetStateVideoPanel(isOpenVideoPanel, data.howenDevice.otherId, data.howenDevice.channels, false, dateStart, dateEnd, e.target.value);
  }

  componentWillUnmount() {
    const { onSetStateVideoPanel, speedPlay } = this.props;
    onSetStateVideoPanel(false, null, null, false, null, null, speedPlay);
  }

  render() {
    const { speedPlay } = this.props;

    const speeds = [2, 4, 8, 16];

    return (
      <div>
        <InputLabel>Скорость проигрывания видео</InputLabel>
        <Select
          style={{ minWidth: "250px", height: "36px", color: "#888888" }}
          onChange={this.onHandleChangeStore.bind(this)}
          value={speedPlay}
        >
          {speeds.map((x, index) => {
            return (
              <MenuItem key={index} value={x} className={styles.MuiButtonBase_resolve}>
                x{x}
              </MenuItem>
            );
          })}
        </Select>
      </div>
    );
  }
}

export default withCars(withChoosedCar(withVideoTools(React.memo(IntelligenceVidioPlayer))));
